import React from 'react'

export default function BenefitRow({ text, iconSrc }) {
  const src = iconSrc || undefined

  return (
    <div className="traffic-fine-package-benefit-row">
      <img
        src={src}
        alt=""
        className={src ? 'traffic-fine-package-benefit-icon' : 'traffic-fine-package-benefit-icon is-hidden'}
        onError={(e) => {
          e.currentTarget.style.display = 'none'
        }}
      />
      <div className="traffic-fine-package-benefit-text">{text}</div>
    </div>
  )
}
